const de = {
  common: {
    ok: "OK!",
    cancel: "Abbrechen",
    back: "Zurück",
  },
  welcomeScreen: {
    readyForLaunch: "Bereit zum Start",
    exciting: "Es ist aufregend!",
  },
  errorScreen: {
    title: "Oops! Etwas ist schiefgelaufen",
    friendlySubtitle:
      "Es tut uns leid für die Unannehmlichkeiten. Bitte versuch, die App neu zu starten.",
    contactSupport: "Support kontaktieren",
    reset: "APP NEU STARTEN",
  },
  emptyStateComponent: {
    generic: {
      heading: "Keine Daten vorhanden",
      content: "Noch keine Daten gefunden. Versuchen Sie, die App neu zu laden.",
      button: "Nochmal versuchen",
    },
  },
}

export default de
export type Translations = typeof de
